









































































































































































































































import { Component, Vue } from "vue-property-decorator";
import _ from "lodash";
import { ScoreboardEventBreakdownEmployeeScore } from "@/api/models/ScoreboardEventBreakdownEmployeeScore";
import loading from "@/components/loader/loading.vue";
import { addDayOnDate, dateFormat } from "@/common/date_format";
import { monthStamp, sixMonthStamp } from "@/tool/beginAtEndAt";
import moment from "moment";
import MessageForm from "./MessageForm.vue";
import { checkSelfRole } from "@/common/role_utils";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line as LineChart } from "vue-chartjs/legacy";
import { EventLineChart } from "@/api";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

@Component({
  components: {
    loading,
    MessageForm,
    LineChart,
  },
})
export default class ScoreboardSummaryCard extends Vue {
  title = this.$route.query.title;
  sortList = true;
  startDate: string | null = null;
  endDate: string | null = null;
  formErrors = "";
  showStartDate = false;
  showEndDate = false;
  formattedStartDate = "";
  formattedEndDate = "";
  initialStartDate: string | null = null;
  initialEndDate: string | null = null;
  poster = false;
  dialog = false;
  isCalendarView = false;
  counter = 0;
  employeeIds: number[] = [];
  eventMetricId = this.$route.params.eventId;

  options = {
    responsive: true,
    maintainAspectRatio: false,
  };

  created() {
    this.fetchCalendarView();
    this.fetchDatasets();
  }

  get isOwner() {
    return checkSelfRole("owner");
  }

  clearDate() {
    const { beginAt, endAt } = monthStamp();
    this.startDate = beginAt;
    this.endDate = moment(endAt)
      .subtract(1, "day")
      .format("YYYY-MM-DD");
    this.selectedDate();
  }

  get stateStartDate() {
    return this.$store.getters["scoreboard/startDate"];
  }

  get stateEndDate() {
    return this.$store.getters["scoreboard/endDate"];
  }

  formatDate(date: string, isStartDate: boolean) {
    if (isStartDate) this.formattedStartDate = dateFormat(date);
    else this.formattedEndDate = dateFormat(date);
  }

  formatMonthDate(date: string) {
    return moment(date).format("MMM/D");
  }

  formatDay(date: string) {
    return moment(date).format("dddd");
  }

  get breakDownList() {
    let list;
    this.employeeIds = [];
    if (this.$route.query.title === "Company") {
      list = this.$store.getters["scoreboard/companyBreakdown"];
      this.employeeIds = list?.employeeScores?.map(
        (employee: ScoreboardEventBreakdownEmployeeScore) =>
          employee.employeeId,
      );
    } else {
      const deptlist = this.$store.getters["scoreboard/departmentBreakdown"];
      list = deptlist[this.$route.query.deptId?.toString()];
      this.employeeIds = list?.employeeScores?.map(
        (employee: ScoreboardEventBreakdownEmployeeScore) =>
          employee.employeeId,
      );
    }
    return list;
  }

  get breakdownListBYDates() {
    let list;
    if (this.$route.query.title === "Company") {
      list = this.$store.getters["scoreboard/companyScoreboardBreakdownDates"];
    } else {
      list = this.$store.getters[
        "scoreboard/departmentScoreboardBreakdownsDates"
      ];
    }
    return list;
  }

  get calendarDays() {
    if (!this.startDate || !this.endDate) {
      const { beginAt, endAt } = monthStamp();
      this.startDate = beginAt;
      this.endDate = endAt;
    }
    // eslint-disable-next-line
    const days: any[] = [];

    const data = this.breakdownListBYDates || [];

    for (
      let d = moment(this.startDate).startOf("day");
      d.isSameOrBefore(moment(this.endDate).startOf("day"));
      d.add(1, "day")
    ) {
      const dateStr = d.format("YYYY-MM-DD");

      // Find event data for this date
      const event = data.find(
        // eslint-disable-next-line
        (item: any) => dateStr === item.date.split("T")[0],
      );

      if (event) {
        days.push({
          ...event,
          date: dateStr,
          hasEvent: true,
        });
      } else {
        days.push({
          date: dateStr,
          groupTotal: 0,
          eventMetricId: 0,
          leaderEmployee: "",
          hasEvent: false,
        });
      }
    }

    return days;
  }

  get employeeScores() {
    const list = this.breakDownList.employeeScores;
    return this.sortList ? list : _.reverse(list);
  }

  get employeeTotal() {
    const totals = this.breakDownList.employeeScores?.map(
      (employee: ScoreboardEventBreakdownEmployeeScore) => employee.total,
    );
    const total = totals?.reduce((a: number, b: number) => {
      return a + b;
    }, 0);
    return total;
  }
  backToDetail() {
    this.$router.back();
  }
  employeeBreakDown(i: number, firstName: string) {
    if (this.$route.params.eventId == "-22") {
      return;
    }
    if (
      this.$route.params.eventId === "-20" ||
      this.$route.params.eventId === "-21"
    ) {
      this.$router.push({
        path: `/scoreboard/breakdown/culture/${this.$route.params.eventId}`,
        query: {
          title: firstName,
          eventName: `${this.breakDownList.eventMetricName} ${firstName}`,
          empId: i.toString(),
          deptId: this.$route.query.deptId,
          isPoster: this.$route.query.isPoster,
        },
      });
      return;
    }
    this.$router.push({
      path: `/scoreboard/breakdown/${this.$route.params.eventId}`,
      query: {
        title: firstName,
        eventName: this.breakDownList.eventMetricName,
        empId: i.toString(),
        deptId: this.$route.query.deptId,
        isPoster: this.$route.query.isPoster,
      },
    });
  }
  giverOrReceiver() {
    if (this.breakDownList?.eventMetricName === "5 Star Moment") {
      if (this.$route.fullPath === "/scoreboard/-1?title=Company&isPoster=true")
        return "Giver";
      else return "Receiver";
    }
  }
  companyOrDepartmentBreakdown(date?: string) {
    if (
      this.eventMetricId === "-20" ||
      this.eventMetricId === "-21" ||
      this.eventMetricId === "-22"
    ) {
      return;
    }
    this.$router.push({
      path: `/scoreboard/breakdown/${this.$route.params.eventId}`,
      query: {
        title: this.title,
        eventName: this.breakDownList.eventMetricName,
        deptId: this.$route.query.deptId,
        isPoster: this.$route.query.isPoster,
        fromCalendar: this.isCalendarView ? "true" : "false",
        date: date || "",
      },
    });
  }
  async selectedDate() {
    if (this.startDate && this.endDate) {
      const filteredDate = {
        startDate: this.startDate,
        endDate: this.endDate,
      };

      if (this.startDate < this.endDate) {
        this.formErrors = "";
        try {
          await this.$store.dispatch(
            "scoreboard/setStartEndDate",
            filteredDate,
          );
          if (
            this.startDate !== this.initialStartDate ||
            this.endDate !== this.initialEndDate
          ) {
            this.$store.dispatch("scoreboard/fetchCompanyScoreboards", {
              startDate: filteredDate.startDate,
              endDate: addDayOnDate(filteredDate.endDate),
            });
          }
          if (
            this.$route.params.eventId == "-20" ||
            this.$route.params.eventId == "-21"
          ) {
            if (this.$route.query.deptId) {
              this.$store.dispatch(
                "scoreboard/loadDepartmentCultureBreakdown",
                {
                  departmentId: this.$route.query.deptId,
                  eventMetricId: this.$route.params.eventId,
                  beginDate: filteredDate.startDate,
                  endDate: addDayOnDate(filteredDate.endDate),
                },
              );
            } else {
              this.$store.dispatch("scoreboard/fetchCompanyCultureScores", {
                eventMetricId: this.$route.params.eventId,
                beginDate: this.startDate,
                endDate: addDayOnDate(this.endDate || ""),
              });
            }
          } else if (this.$route.params.eventId == "-22") {
            if (this.$route.query.deptId) {
              this.$store.dispatch(
                "scoreboard/loadDepartmentCompositionBreakdown",
                {
                  departmentId: this.$route.query.deptId,
                  eventMetricId: this.$route.params.eventId,
                  beginDate: filteredDate.startDate,
                  endDate: addDayOnDate(filteredDate.endDate),
                },
              );
            } else {
              this.$store.dispatch(
                "scoreboard/loadCompanyCompositionBreakdown",
                {
                  eventMetricId: this.$route.params.eventId,
                  beginDate: this.startDate,
                  endDate: addDayOnDate(this.endDate || ""),
                },
              );
            }
          } else {
            if (this.$route.query.deptId) {
              this.$store.dispatch("scoreboard/loadDepartmentBreakdown", {
                departmentId: this.$route.query.deptId,
                eventMetricId: this.$route.params.id,
                groupByPoster: this.$route.query.isPoster,
                beginDate: filteredDate.startDate,
                endDate: addDayOnDate(filteredDate.endDate),
              });
            } else {
              this.$store.dispatch("scoreboard/loadCompanyBreakdown", {
                eventMetricId: this.$route.params.eventId,
                groupByPoster: this.$route.query.isPoster,
                beginDate: filteredDate.startDate,
                endDate: addDayOnDate(filteredDate.endDate),
              });
            }
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        this.formErrors = "start date should not be greater than end date";
      }
    } else {
      this.formErrors = "require both dates";
    }
  }

  getEmployeeName(employee: ScoreboardEventBreakdownEmployeeScore): string {
    const anynomous = ["Family", "Visitor", "Patient"];
    const name = anynomous.find(name => name == employee.nonEmployeeName);
    if (this.poster) {
      if (name) return name;
      return `${employee.nonEmployeeName} - ${employee.title} - ${employee.primaryDepartmentName}`;
    }
    return `${employee.employeeFirstName} ${employee.employeeLastName} - ${employee.title} - ${employee.primaryDepartmentName}`;
  }

  destroyed() {
    this.$store.dispatch("scoreboard/clearBreakdown");
    if (!this.$route.path.includes("scoreboard"))
      this.$store.dispatch("scoreboard/setStartEndDate", {
        startDate: null,
        endDate: null,
      });
  }

  fetchCalendarView() {
    this.eventMetricId = this.$route.params.eventId;
    if (this.stateStartDate) {
      this.startDate = this.stateStartDate;
      this.initialStartDate = this.stateStartDate;
    }
    if (this.stateEndDate) {
      this.endDate = this.stateEndDate;
      this.initialEndDate = this.stateEndDate;
    }
    if (this.$route.query.isPoster === "true") {
      this.poster = true;
    }
    if (this.isCalendarView) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (this.$route.query.title === "Company") {
        this.$store.dispatch("scoreboard/loadCompanyBreakdownDates", {
          eventMetricId: this.$route.params.eventId,
          groupByPoster: this.poster,
          beginDate: this.startDate,
          endDate: addDayOnDate(this.endDate || ""),
          timezone,
        });
      } else {
        this.$store.dispatch("scoreboard/loadDepartmentBreakdownDates", {
          departmentId: this.$route.query.deptId,
          eventMetricId: this.$route.params.eventId,
          groupByPoster: this.poster,
          beginDate: this.startDate,
          endDate: addDayOnDate(this.endDate || ""),
          timezone,
        });
      }
    } else {
      if (this.$route.query.title === "Company") {
        if (this.eventMetricId == "-20" || this.eventMetricId == "-21") {
          this.$store.dispatch("scoreboard/fetchCompanyCultureScores", {
            eventMetricId: this.eventMetricId,
            beginDate: this.startDate,
            endDate: addDayOnDate(this.endDate || ""),
          });
          return;
        } else if (this.eventMetricId == "-22") {
          this.$store.dispatch("scoreboard/loadCompanyCompositionBreakdown", {
            eventMetricId: this.eventMetricId,
            beginDate: this.startDate,
            endDate: addDayOnDate(this.endDate || ""),
          });
          return;
        } else {
          this.$store.dispatch("scoreboard/loadCompanyBreakdown", {
            eventMetricId: this.eventMetricId,
            groupByPoster: this.poster,
            beginDate: this.startDate,
            endDate: addDayOnDate(this.endDate || ""),
          });
        }
      } else {
        if (this.eventMetricId == "-20" || this.eventMetricId == "-21") {
          this.$store.dispatch("scoreboard/loadDepartmentCultureBreakdown", {
            departmentId: this.$route.query.deptId,
            eventMetricId: this.eventMetricId,
            beginDate: this.startDate,
            endDate: addDayOnDate(this.endDate || ""),
          });
          return;
        } else if (this.eventMetricId == "-22") {
          this.$store.dispatch(
            "scoreboard/loadDepartmentCompositionBreakdown",
            {
              departmentId: this.$route.query.deptId,
              eventMetricId: this.eventMetricId,
              beginDate: this.startDate,
              endDate: addDayOnDate(this.endDate || ""),
            },
          );
          return;
        } else {
          this.$store.dispatch("scoreboard/loadDepartmentBreakdown", {
            departmentId: this.$route.query.deptId,
            eventMetricId: this.eventMetricId,
            groupByPoster: this.poster,
            beginDate: this.startDate,
            endDate: addDayOnDate(this.endDate || ""),
          });
        }
      }
    }
  }

  getEventTitle(): string {
    if (this.breakDownList) {
      return this.breakDownList.eventMetricName;
    } else {
      return this.breakdownListBYDates[0]?.eventMetricName || "";
    }
  }

  fetchDatasets() {
    const { beginAt, endAt } = sixMonthStamp(this.endDate || undefined);
    if (this.$route.query.title === "Company") {
      this.$store.dispatch("scoreboard/fetchDatasets", {
        eventMetricId: this.$route.params.eventId,
        groupByPoster: this.poster,
        beginAt,
        endAt,
      });
    } else {
      this.$store.dispatch("scoreboard/fetchDepartmentDatasets", {
        eventMetricId: this.$route.params.eventId,
        departmentId: this.$route.query.deptId,
        groupByPoster: this.poster,
        beginAt,
        endAt,
      });
    }
  }

  get dataSets() {
    const data = this.$store.getters[
      "scoreboard/chartDatasets"
    ] as EventLineChart;
    if (data) {
      const res = {
        labels: data.labels,
        datasets: data.data,
      };
      return res;
    }
    return null;
  }
}
